export default "__VITE_PUBLIC_ASSET__83e64316__"